import { useDispatch, useSelector } from 'react-redux'
import Schedule from '../../components/schedule/Schedule'
import AllCourseList from './all-course-list/AllCourseList'
import './studentDashboard.scss'
import { useEffect } from 'react'
import { getStudentCourse } from '../../store/builders/studentCourse/studentCourse.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'
import { schedule, UI_CONSTANT } from '../../utility/constants'
import Loader from '../../components/loader/Loader'


function StudentDashboard() {
  const dispatch = useDispatch()
  const userName = useSelector((state) => state?.auth?.user?.result?.userData?.userName)
  const studentId = useSelector((state) => state?.auth?.user?.result?.studentId)
  const { studentCourseData, loading } = useSelector((state) => state?.studentCourse)

  useEffect(() => {
    dispatch(getStudentCourse(studentId))
  }, [])
  
  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='studentSchedule-wrapper'>
          <div className='studentSchedule-header'>
            <div className='studentSchedule-header-left'>
              <p>Hello, {capitalizeFirstLetter(userName)}</p>
              <p className='breadCrumb'>{UI_CONSTANT.DASHBOARD}</p>
            </div>
          </div>

          <div className='student-schedule-calender-wrapper'>
            <Schedule schedule={schedule} />

            <div className='studentSchedule-right-div'>
              <h2 className='myCourse-header'>My course</h2>

              <AllCourseList courseList={studentCourseData} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default StudentDashboard
